import React, { useState } from 'react';
import { OverviewCards } from '../components/admin/OverviewCards';
import { RetentionTable } from '../components/admin/RetentionTable';
import { ActiveUsersChart } from '../components/admin/ActiveUsersChart';
import { SessionMetrics } from '../components/admin/SessionMetrics';
import { LearningOutcomes } from '../components/admin/LearningOutcomes';
import { AIUsagePanel } from '../components/admin/AIUsagePanel';
import { FeedbackPanel } from '../components/admin/FeedbackPanel';
import '../styles/AdminDashboard.css';

type TabKey = 'overview' | 'retention' | 'engagement' | 'sessions' | 'learning' | 'ai' | 'feedback';

const TABS: { key: TabKey; label: string }[] = [
  { key: 'overview', label: 'Overview' },
  { key: 'retention', label: 'Retention' },
  { key: 'engagement', label: 'Engagement' },
  { key: 'sessions', label: 'Sessions' },
  { key: 'learning', label: 'Learning' },
  { key: 'ai', label: 'AI Usage' },
  { key: 'feedback', label: 'Feedback' },
];

export const AdminDashboardPage: React.FC = () => {
  const [activeTab, setActiveTab] = useState<TabKey>('overview');

  return (
    <div className="admin-dashboard">
      <div className="admin-header">
        <h1>Admin Analytics</h1>
        <p>Platform-wide metrics across all students</p>
      </div>

      <div className="admin-tabs">
        {TABS.map((tab) => (
          <button
            key={tab.key}
            className={`admin-tab ${activeTab === tab.key ? 'active' : ''}`}
            onClick={() => setActiveTab(tab.key)}
          >
            {tab.label}
          </button>
        ))}
      </div>

      <div className="admin-tab-content">
        {activeTab === 'overview' && <OverviewCards />}
        {activeTab === 'retention' && <RetentionTable />}
        {activeTab === 'engagement' && <ActiveUsersChart />}
        {activeTab === 'sessions' && <SessionMetrics />}
        {activeTab === 'learning' && <LearningOutcomes />}
        {activeTab === 'ai' && <AIUsagePanel />}
        {activeTab === 'feedback' && <FeedbackPanel />}
      </div>
    </div>
  );
};
